import { Tabs } from 'antd';
import React from 'react';
import SettingsGeneralTab from './ViewSettingsProfileGeneral'
import {SettingsFTP, SettingsWeight} from './ViewSettingsProfileMeasures'
import SettingsPasswordTab from './ViewSettingsProfilePassword'

const { TabPane } = Tabs;

function ViewSettingsProfile() {
  return (
    <Tabs defaultActiveKey="1" >
      <TabPane tab="Общие" key="1">
        <SettingsGeneralTab />
      </TabPane>
      <TabPane tab="FTP" key="2">
        <SettingsFTP/>
      </TabPane>
      <TabPane tab="Вес" key="3">
        <SettingsWeight/>
      </TabPane>
      <TabPane tab="Пароль" key="4">
        <SettingsPasswordTab />
      </TabPane>
    </Tabs>
  );
}

export default ViewSettingsProfile;
